import { Component, Input, OnInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-sidebar-wizard',
  templateUrl: './sidebar-wizard.component.html',
  styleUrls: ['./sidebar-wizard.component.scss']
})
export class SidebarWizardComponent implements OnInit {
  activeStep = 1;
  
  private eventStepSubscription: Subscription;
  @Output() activeStepEmitter = new EventEmitter<number>();

  /* Lista del sidebar a mostrar */
  @Input() listStep:Object;
  @Input() eventStepChange: Observable<void>;
  
  dataCuerpo:any = [
    {
      'id': 1,
      'nombre': 'Maestros',
    },
    {
      'id': 2,
      'nombre': 'Bomberos',
    },
    {
      'id': 3,
      'nombre': 'Auxiliares administrativos',
    },
    {
      'id': 4,
      'nombre': 'Técnicos de Hacienda',
    },
  ];
  valuesListCuerpo:any;

  valuesListFormaAcceso:any;

  radioSexoModel:any = null;
  radioOptionsSexo: any[] = [
    {
      'id': 'h',
      'text': 'Hombre',
    },
    {
      'id': 'm',
      'text': 'Mujer',
    },
  ];
  radioOptionsTitulacion: any[] = [
    {
      'id': 's',
      'text': 'Sí',
    },
    {
      'id': 'n',
      'text': 'No',
    },
  ];
  radioOptionsEspecialidad: any[] = [
    {
      'id': 'm',
      'text': 'Misma',
    },
    {
      'id': 'd',
      'text': 'Diferente',
    },
  ];

  selectOptionsProvincias: any[];
  selectModelProv:any = null;
  selectOptionsMunicipios: any[];
  selectModelMuni:any = null;

  checkboxCondicionesUso:boolean = null;

  constructor() {  
    }
   

  ngOnInit() {
    
    this.eventStepSubscription = this.eventStepChange.subscribe((status) => this.checkStep(status));
  }


  checkStep(status) {
    if (status === "next") {
      this.nextStep();
    } else if (status === "back") {
      this.prevStep();
    }
    
  }

  /**
   * Incrementa activeStep
   */
  nextStep() {
    
    if (this.activeStep < Object.keys(this.listStep).length) {
      this.activeStep++;
      this.activeStepEmitter.emit(this.activeStep);
    } else {
      
    }
  }

  /**
   * Decrementa activeStep
   */
  prevStep() {
    if (this.activeStep > 1) {
      this.activeStep--;
      this.activeStepEmitter.emit(this.activeStep);
    }
  }

  
  ngOnDestroy() {
    this.eventStepSubscription.unsubscribe();
  }

}
